// extracted by mini-css-extract-plugin
export default {"search":"Search_search__v2CqF","noposts":"Search_noposts__pD8NJ"};